export default function Team() {
  const teamMembers = [
    {
      icon: 'ri-user-star-line',
      title: 'مدير مشروع',
      description: 'الإشراف العام على الملتقى والتنسيق بين جميع الفرق',
      color: 'from-[#1B5E20] to-[#2E7D32]',
      count: '1'
    },
    {
      icon: 'ri-shake-hands-line',
      title: 'منسق شراكات',
      description: 'إدارة العلاقات مع الشركاء والرعاة والجهات المشاركة',
      color: 'from-[#D4AF37] to-[#B8941F]',
      count: '1'
    },
    {
      icon: 'ri-file-edit-line',
      title: 'مسؤول محتوى',
      description: 'إعداد وتنسيق المحتوى العلمي وأوراق العمل',
      color: 'from-[#2E7D32] to-[#1B5E20]',
      count: '1'
    },
    {
      icon: 'ri-megaphone-line',
      title: 'مسؤول إعلام',
      description: 'إدارة الحملات الإعلامية والتغطية الإعلامية',
      color: 'from-[#1B5E20] to-[#0D3D10]',
      count: '1'
    },
    {
      icon: 'ri-calculator-line',
      title: 'محاسب',
      description: 'إدارة الموازنة والمصروفات والتقارير المالية',
      color: 'from-[#D4AF37] to-[#8B7520]',
      count: '1'
    }
  ];

  return (
    <section id="team" className="py-12 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-8">
        <div className="text-center mb-16">
          <div className="inline-block mb-4">
            <span className="text-[#1B5E20] text-sm font-bold tracking-wider uppercase">فريق العمل</span>
            <div className="h-1 w-16 bg-[#1B5E20] mt-2 mx-auto"></div>
          </div>
          <h2 className="text-5xl font-bold text-[#1B5E20] mb-6">فريق العمل المقترح</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            فريق متخصص ومتكامل لضمان نجاح الملتقى وتحقيق أهدافه
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {teamMembers.map((member, index) => (
            <div
              key={index}
              className="group relative bg-gradient-to-br from-gray-50 to-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100 overflow-hidden"
            >
              <div className={`absolute top-0 right-0 w-32 h-32 bg-gradient-to-br ${member.color} opacity-5 rounded-bl-full`}></div>
              <div className="relative z-10">
                <div className="flex items-start justify-between mb-6">
                  <div className={`w-16 h-16 rounded-xl bg-gradient-to-br ${member.color} flex items-center justify-center group-hover:scale-110 transition-transform duration-300`}>
                    <i className={`${member.icon} text-3xl text-white`}></i>
                  </div>
                  <div className="w-12 h-12 rounded-full bg-[#F5F5DC] flex items-center justify-center">
                    <span className="text-xl font-bold text-[#1B5E20]">{member.count}</span>
                  </div>
                </div>
                <h3 className="text-2xl font-bold text-gray-800 mb-3">{member.title}</h3>
                <p className="text-gray-600 leading-relaxed">{member.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-br from-[#1B5E20] to-[#0D3D10] rounded-3xl p-12 text-center text-white">
          <div className="max-w-3xl mx-auto">
            <div className="w-20 h-20 rounded-full bg-white/20 flex items-center justify-center mx-auto mb-6">
              <i className="ri-team-line text-4xl text-white"></i>
            </div>
            <h3 className="text-3xl font-bold mb-4">فريق متكامل ومتخصص</h3>
            <p className="text-white/90 text-lg leading-relaxed mb-8">
              يضم فريق العمل نخبة من المتخصصين في مختلف المجالات لضمان التنظيم الاحترافي والتنفيذ المتميز للملتقى
            </p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="bg-white/10 rounded-xl p-6 backdrop-blur-sm">
                <div className="text-4xl font-bold text-[#D4AF37] mb-2">5</div>
                <div className="text-white/80 text-sm">أعضاء فريق أساسي</div>
              </div>
              <div className="bg-white/10 rounded-xl p-6 backdrop-blur-sm">
                <div className="text-4xl font-bold text-[#D4AF37] mb-2">+20</div>
                <div className="text-white/80 text-sm">متطوع داعم</div>
              </div>
              <div className="bg-white/10 rounded-xl p-6 backdrop-blur-sm">
                <div className="text-4xl font-bold text-[#D4AF37] mb-2">+10</div>
                <div className="text-white/80 text-sm">خبير ومستشار</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
